let hostname = location.hostname;
hostname = hostname.substring(hostname.indexOf("."));
let appHost = `${location.protocol}//api${hostname}`;
const baseUrl = `${appHost}/zmtx/`;
import axios from "axios";

//上传图片-patient
export function DownloadImage(data) {
  // console.log(data,'data')
  return axios.get(`${baseUrl}wechat/download-image-tmp`, data);
}
//
//保存为本人领药
export function saveSelfReceived(data) {
  return axios.post(`${baseUrl}pap-audit/save-self-received`, data);
}
//添加待领药人
export function addFamily(data) {
  return axios.post(`${baseUrl}pap-audit/add-family`, data);
}
//查询待领药人
export function getFamilys(data) {
  return axios.post(`${baseUrl}pap-audit/get-familys`, data);
}
//设置代领人本阶段领药
export function setFamily(data) {
  return axios.post(`${baseUrl}pap-audit/set-family`, data);
}
//删除代领人
export function deleteFamily(data) {
  return axios.post(`${baseUrl}pap-audit/delete-family`, data);
}
//通过idsn查找代领人
export function checkFamily(data) {
  return axios.post(`${baseUrl}pap-audit/check-family`, data);
}
//获取待领人的申请信息
export function getAgentApply(data) {
  return axios.post(`${baseUrl}pap-audit/get-agent-apply`, data);
}
//获取待领人审核项
export function getCheckItems(data) {
  return axios.post(`${baseUrl}pap-audit/get-check-items`, data);
}
//提交代领人的全部材料
export function saveAgentApply(data) {
  return axios.post(`${baseUrl}pap-audit/save-agent-apply`, data);
}
//提交代领人审核项的材料
export function uploadAgentCheckItem(data) {
  return axios.post(`${baseUrl}pap-audit/upload-agent-check-item`, data);
}
//删除代领人审核项的材料
export function deleteFamilyAttach(data) {
  return axios.post(`${baseUrl}pap-audit/delete-family-attach`, data);
}
//撤销申请
export function deleteApply(data) {
  return axios.post(`${baseUrl}pap-audit/delete-apply`, data);
}